import { atom } from 'recoil';

export const localCart = atom<number>({
  key: 'localCart',
  default: 0,
});
